import React, { useEffect } from "react";
import {
  initMercadoPago,
  CardPayment as MPCardPayment,
} from "@mercadopago/sdk-react";

import { Totals } from "../../models/checkout_model";
import axios from "../../middleware/axios";
import { UserType } from "../../models/user_model";
import { OrderDbType } from "../../models/order_model";
initMercadoPago(process.env.REACT_APP_MP_KEY!);

////test cards
/// Masterdcard 5474 9254 3267 0366 | 123}  11/30
/// Masterdcard Debito 5579 0534 6148 2647 | 1234 | 11/30
/// Visa 4075 5957 1648 3764 | 123 | 11/30

type PaymentFormProps = {
  totals: Totals;
  user: UserType;
  onSuccess: any;
  setError_message: any;
  order_id: string;
};
const PaymentForm: React.FC<PaymentFormProps> = ({
  totals,
  user,
  onSuccess,
  setError_message,
  order_id,
}) => (
  <CardPayment
    setError_message={setError_message}
    totals={totals}
    user={user}
    onSuccess={onSuccess}
    order_id={order_id}
  />
);

type CardPaymentProps = {
  totals: Totals;
  user: UserType;
  onSuccess: any;
  setError_message: any;
  order_id: string;
};
const CardPayment: React.FC<CardPaymentProps> = ({
  totals,
  user,
  onSuccess,
  setError_message,
  order_id,
}) => {
  useEffect(() => {
    return () => {
      // Clean up the controller when the component unmounts
      ///@ts-ignore next-line
      window.cardPaymentBrickController.unmount();
    };
  }, []);

  const onSubmit = async (param: any): Promise<void> => {
    //@ts-ignore
    // callback called when clicking the submit data button
    return new Promise(async (resolve, reject) => {
      try {
        const response = await axios.post("/scriptsPaymentMpMakePayment", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: { ...param, user_id: user.uid, order_id: order_id },
        });
        if (response.data.error) {
          setError_message(response.data.message);
          return reject(void 0);
        }
        const order_obj = {} as OrderDbType;
        order_obj.mp_payment = {
          authorization_code: response.data.authorization_code,
          card: response.data.card.last_four_digits,
        };
        order_obj.meses = response.data.installments;
        order_obj.ipgTransactionId = response.data.payment_method_id;
        onSuccess(true, order_obj);
        return resolve(void 0);
      } catch (error) {
        console.log("orderResume.tsx:307 | error ", error);
        reject(void 0);
      }
    });
  };
  const onError = async (error: any) => {
    // callback called for all Brick error cases
    console.log(error);
  };
  const onReady = async () => {
    console.log("orderResume.tsx:344 | Brick is ready");
  };

  return (
    <div className="row ">
      <div className="col-md-12">
        <MPCardPayment
          initialization={{
            amount: totals.total,
            payer: {
              email: user.email!,
            },
          }}
          onSubmit={onSubmit}
          onReady={onReady}
          onError={onError}
          locale="es-MX"
        />
      </div>
    </div>
  );
};

export default PaymentForm;
